module.exports = __webpack_public_path__ + "files/73da4cad4cd12c9457c97150546dcabb.png";